// extracted by mini-css-extract-plugin
export default {"back":"Back_back__vD-nr"};